import {useState, createContext, useLayoutEffect, type ReactNode} from 'react'
import {IS_SERVER} from '@github-ui/ssr-utils'

const RenderPhase = {
  ServerRender: 'ServerRender',
  ClientHydrate: 'ClientHydrate',
  ClientRender: 'ClientRender',
} as const

type RenderPhase = (typeof RenderPhase)[keyof typeof RenderPhase]

const RenderPhaseContext = createContext<RenderPhase>(RenderPhase.ClientRender)

/**
 * @deprecated This component is deprecated. Please use `useRuntimeEnvironment` instead. You can think of `useRenderPhase` as 'environment sniffing' vs `useRuntimeEnvironment`'s 'feature detection' approach.
 * This is left in for timing related reasons, but will be removed in a future release.
 */
export function RenderPhaseProvider({wasServerRendered, children}: {wasServerRendered: boolean; children: ReactNode}) {
  const [renderPhase, setRenderPhase] = useState<RenderPhase>(() => {
    if (IS_SERVER) {
      return RenderPhase.ServerRender
    }
    if (wasServerRendered) {
      return RenderPhase.ClientHydrate
    }
    return RenderPhase.ClientRender
  })

  useLayoutEffect(() => {
    if (renderPhase === RenderPhase.ClientRender) return
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setRenderPhase(RenderPhase.ClientRender)
  }, [renderPhase])

  return <RenderPhaseContext value={renderPhase}>{children}</RenderPhaseContext>
}
